import { createSlice } from "@reduxjs/toolkit";
import { brandUpdateBoolean } from "./brandAsyncThunk";

const brandUpdateBooleanSlice = createSlice({
  name: "brand",
  initialState: {
    isLoading: false,
    isSuccess: false,
    failCode: 0,
    failMessage: "",
  },
  reducers: {},
  extraReducers: {
    [brandUpdateBoolean.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.failCode = 0;
    },
    [brandUpdateBoolean.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [brandUpdateBoolean.rejected]: (state, action) => {
      state.isLoading = false;
      state.failCode = action.payload.status;
      state.failMessage = action?.payload?.data?.message;
    },
  },
});

export default brandUpdateBooleanSlice.reducer;
